import { Box } from "components/ui";
import React, { ComponentProps } from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

interface SectionProps {
	children: React.ReactNode;
}

const Section = ({ padding = 47, backgroundColor = "$neutral25", borderRadius = 12, ...props }: ComponentProps<typeof Box> & SectionProps) => {
	const isMobile = useIsMobile();
	return (
		<Box padding={isMobile ? 12 : padding} backgroundColor={backgroundColor} borderRadius={borderRadius} {...props}>
			{props.children}
		</Box>
	);
};

export default Section;
